import { action } from 'satcheljs';
import type AccountsFeedbackInitSource from './store/schema/AccountsFeedbackInitSource';

export const showAddAccountFailureFeedbackDialog = action(
    'showAddAccountFailureFeedbackDialog',
    (source: AccountsFeedbackInitSource) => ({
        source,
    })
);

export const showDisconnectFeedbackDialog = action(
    'showDisconnectFeedbackDialog',
    (accountAddedInSameSession: boolean, isErrorDialogReferral: boolean) => ({
        accountAddedInSameSession,
        isErrorDialogReferral,
    })
);
